/*
Antoine Model
log10(P) = A − (B / (T + C))
    P = vapor pressure (bar)
    T = temperature (K)
*/


export const Rg = 8.3144;

export function roundQuantity(input,n_digits) {
  if (!isNaN(input) && typeof input === "number") {
    // Input is a valid floating-point number
    const roundedValue = parseFloat(input.toFixed(n_digits));
    return roundedValue;
  } else {
    // Input is not a valid number
    return input;
  }
}

export function Antoine_T_P(T, A,B,C) {
    // Given a temperature in K, get saturation pressure in bar;
    const log_P = A-(B/(T+C));
    const P = 10.0 ** log_P;
    return P;
  }
  
export function Antoine_P_T(P,A,B,C) {
    // Given a pressure P in bar, get boiling point in K;
    const log_P = Math.log10(P);
    const T=B/(A-log_P)-C;
    return T;
  }



export function wilson_gamma_i(x1str,modelParams){
  const x1 = parseFloat(x1str);
  const {Lambda_12, Lambda_21} = modelParams;
  const x2 = 1 - x1;
  const gamma1 = Math.exp(-Math.log(x1+x2*Lambda_12)+x2*(Lambda_12/(x1+x2*Lambda_12)-Lambda_21/(x2+x1*Lambda_21)));
  const gamma2 = Math.exp(-Math.log(x2+x1*Lambda_21)+x1*(Lambda_21/(x2+x1*Lambda_21)-Lambda_12/(x1+x2*Lambda_12)));
  return [gamma1, gamma2];

}


export function NRTL_gamma_i(x1str,modelParams){
  const x1 = parseFloat(x1str);
  const {Tau_12, Tau_21, Alpha} = modelParams;
  const x2 = 1- x1;
  const G_12 = Math.exp(-Alpha*Tau_12);
  const G_21 = Math.exp(-Alpha*Tau_21);
  const gamma1 = Math.exp(x2**2*(Tau_21*(G_21/(x1+x2*G_21))**2+Tau_12*G_12/(x2+x1*G_12)**2));
  const gamma2 = Math.exp(x1**2*(Tau_12*(G_12/(x2+x1*G_12))**2+Tau_21*G_21/(x1+x2*G_21)**2));
  return [gamma1, gamma2];

}

export function get_y1_T(P,x1_str, selectedModel, binSys_str) {

  const x1 = parseFloat(x1_str);
  const binSys = binary_sys[selectedModel][binSys_str];
  //alert(binSys_str);

  const c1 = binSys.comp_1, c2 = binSys.comp_2;
  const As1=substances[c1].antoine_params, As2 =substances[c2].antoine_params;
  const modelParams = binSys.modelParams;
  const gamma = models[selectedModel].get_gamma(x1, modelParams);

  function P_total_x(T){
    const P1_sat = Antoine_T_P(T, As1.A, As1.B, As1.C), P2_sat = Antoine_T_P(T, As2.A, As2.B, As2.C);
    return x1*gamma[0]*P1_sat + (1-x1) * gamma[1]*P2_sat;
  }
  let T0 = 1.0 , T1 = 1000000.0;
  while (T1 - T0 > 1e-7){
    const Tm = (T0 + T1) * 0.5;
    if ( P_total_x(Tm) > P ) T1 = Tm;
    else T0 = Tm;
  }

  const T_bubble = (T0 + T1) * 0.5;
  const y1 = x1 * gamma[0] * Antoine_T_P(T_bubble, As1.A, As1.B, As1.C) / P;
return {'T_bubble':T_bubble,
        'y1':y1,
       }

}

//todo 写一个能给出恒沸点和此时x1、y1取值的函数

export function get_Txy_data(P,selectedModel, binSys_str){

  // Get basic Txy data, given P
  const numPoints = 2001;
  const x1s = Array.from({length:numPoints},(_,i)=>i/(numPoints-1));
  const TbY1s = x1s.map((x10)=> get_y1_T(P,x10, selectedModel, binSys_str));
  const Tbs = TbY1s.map((d)=> d.T_bubble );
  const y1s = TbY1s.map((d)=> d.y1 );
  const Txy_data = {Tbs:Tbs,x1s:x1s,y1s:y1s};
  const Tb0 = Tbs[0], Tb1=Tbs[Tbs.length-1];

  // Find azeotrope if exists

  let Tm = -1, xm = -1, azeotrope = 0;
  let x0 = 0.0001 , x1 = 0.9999;
  if ((get_y1_T(P,x0,selectedModel, binSys_str).y1 - x0) *  (get_y1_T(P,x1,selectedModel, binSys_str).y1 - x1) < 0) {

      while (x1 - x0 > 1e-6){
        const xm = (x0 + x1) * 0.5;
        if ((get_y1_T(P,xm,selectedModel, binSys_str).y1 - xm) *  (get_y1_T(P,x1,selectedModel, binSys_str).y1 - x1) < 0) x0 = xm;
        else x1 = xm;
      }

      xm =  (x0 + x1) * 0.5;
      Tm =  get_y1_T(P,xm,selectedModel, binSys_str).T_bubble;
      if (Tb0 - Tm > 0.0001 && Tb1 - Tm > 0.0001) azeotrope = 1;
      else  if (Tm - Tb0 > 0.0001 && Tm - Tb1 > 0.0001) azeotrope = -1;
      else alert('DEBUG: azeotrope wrong');
  }
  

  let xmin = 0,xmax = 1;


  return{
    Txy_data: Txy_data,
    azeotrope: azeotrope,
    Tm: Tm,
    xm: xm,
    xmin: xmin,
    xmax: xmax,
  }
}

export function get_x1_T(P,y1_str, selectedModel, binSys_str) {
  const y1 = parseFloat(y1_str);
  let x0 = 0.0 , x1 = 1.0;
  while (x1 - x0 > 1e-6){
    const xm = (x0 + x1) * 0.5;
    if (get_y1_T(P,xm,selectedModel, binSys_str).y1 < y1 ) x0 = xm;
    else x1 = xm;
  }
  const xe =  (x0 + x1) * 0.5;
  const T =  get_y1_T(P,xe,selectedModel, binSys_str).T_bubble;
  return {T_bubble:T,
    x1:xe,
    //model:selectedModel,
    //system:binSys_str,
  }
}


export const models = {
    'Wilson': {name_cn: '威尔逊模型',
                name_en: 'Wilson Activity Model',
                abbr: 'Wilson',
                'get_gamma': wilson_gamma_i,
                point: 'open',
               },
    'NRTL':      {name_cn:'NRTL模型',
                name_en: 'NRTL Activity Model',
                abbr: 'NRTL',
                'get_gamma': NRTL_gamma_i,
                point: 'closed',
              }
  }
  

//const reader = new FileReader();


export const substances = {'Water': {'name_cn': '水',
  'name_en': 'Water',
  'abbr': 'Water',
  'antoine_params': {'A': 5.08354, 'B': 1663.125, 'C': -45.622},
  'V': 18.07},
 'Ethanol': {'name_cn': '乙醇',
  'name_en': 'Ethanol',
  'abbr': 'Ethanol',
  'antoine_params': {'A': 5.24677, 'B': 1598.673, 'C': -46.424},
  'V': 58.68},
 'Benzene': {'name_cn': '苯',
  'name_en': 'Benzene',
  'abbr': 'Benzene',
  'antoine_params': {'A': 4.72583, 'B': 1660.652, 'C': -1.461},
  'V': 89.41},
 'CCl4': {'name_cn': '四氯化碳',
  'name_en': 'CCl4',
  'abbr': 'CCl4',
  'antoine_params': {'A': 4.02291, 'B': 1221.781, 'C': -45.739},
  'V': 97.09},
 'Methanol': {'name_cn': '甲醇',
  'name_en': 'Methanol',
  'abbr': 'Methanol',
  'antoine_params': {'A': 5.20409, 'B': 1581.341, 'C': -33.5},
  'V': 40.73},
 'Chexane': {'name_cn': '环己烷',
  'name_en': 'Cyclohexane',
  'abbr': 'Chexane',
  'antoine_params': {'A': 4.13983, 'B': 1316.554, 'C': -35.581},
  'V': 108.75},
 'Nhexane': {'name_cn': '正己烷',
  'name_en': 'n-Hexane',
  'abbr': 'Nhexane',
  'antoine_params': {'A': 4.002556, 'B': 1171.53, 'C': -48.784},
  'V': 0.0},
 'Nbutanol': {'name_cn': '正丁醇',
  'name_en': 'n-Butanol',
  'abbr': 'Nbutanol',
  'antoine_params': {'A': 4.54607, 'B': 1351.555, 'C': -93.34},
  'V': 0.0},
 'CH2O2': {'name_cn': '甲酸',
  'name_en': 'Formic Acid',
  'abbr': 'CH2O2',
  'antoine_params': {'A': 4.07008, 'B': 1295.26, 'C': -55.15},
  'V': 37.91},
 'Acetone': {'name_cn': '丙酮',
  'name_en': 'Acetone',
  'abbr': 'Acetone',
  'antoine_params': {'A': 4.42448, 'B': 1312.253, 'C': -32.445},
  'V': 74.05}};
  
  /*{
    'Water':   {name_cn: '水',
                name_en: 'Water',
                abbr: 'Water',
                antoine_params: {A: 5.08354, B:1663.125, C:-45.622, T_lo: 0,T_hi: 133, P_lo: 0.05, P_hi:3.0},
                CC_params: {P0:1.01325, T0:373.15, dHvap:41050},
                color: 'red',
               },
    'Ethanol': {name_cn: '乙醇',
                name_en: 'Ethanol',
                abbr: 'Ethanol',
                antoine_params: {A:5.24677,B:1598.673,C:-46.424, T_lo: 20 ,T_hi: 91, P_lo:0.05 , P_hi:3.0},
                CC_params: {P0:1.01325, T0:351.5, dHvap:42300},
                color: 'blue',
               },

    'Chexane': {name_cn: '环己烷',
                name_en: 'Cyclohexane',
                abbr: 'Chexane',
                antoine_params: {A:4.13983,B:1316.554,C:-35.581, T_lo: 10 ,T_hi: 250, P_lo:0.04 , P_hi:9.0},
                CC_params: {P0:1.01325, T0:353.9, dHvap:33100},
                color: 'green',
               },

    'Benzene': {name_cn: '苯',
               name_en: 'Benzene',
               abbr: 'Benzene',
               antoine_params: {A:4.72583,B:1660.652,C:-1.461, T_lo: 15 ,T_hi: 130, P_lo:0.05 , P_hi:3.5},
               CC_params: {P0:1.01325, T0:353.3, dHvap:33900},
               color: 'orange',
             },    
    'CCl4': {name_cn: '四氯化碳',
             name_en: 'Carbon Tetrachloride',
             abbr: 'CCl4',
             antoine_params: {A:4.02291,B:1221.781,C:-45.739, T_lo: 20 ,T_hi: 80, P_lo:0.1 , P_hi:1.11},
             CC_params: {P0:1.01325, T0:349.8, dHvap:32000},
             color: 'cyan',
            }

  }
            */


export const binary_sys_wilson = {'Nhexane_Benzene': {'comp_1': 'Nhexane',
  'comp_2': 'Benzene',
  'name_cn': '正己烷-苯',
  'name_en': 'n-Hexane / Benzene',
  'abbr': 'Nhexane_Benzene',
  'modelParams': {'Lambda_12': 0.53015, 'Lambda_21': 1.07005}},
 'Ethanol_Nbutanol': {'comp_1': 'Ethanol',
  'comp_2': 'Nbutanol',
  'name_cn': '乙醇-正丁醇',
  'name_en': 'Ethanol / n-Butanol',
  'abbr': 'Ethanol_Nbutanol',
  'modelParams': {'Lambda_12': 0.10176, 'Lambda_21': 2.13872}},
 'Acetone_Water': {'comp_1': 'Acetone',
  'comp_2': 'Water',
  'name_cn': '丙酮-水',
  'name_en': 'Acetone / Water',
  'abbr': 'Acetone_Water',
  'modelParams': {'Lambda_12': 0.16924, 'Lambda_21': 0.4064}},
 'Ethanol_Benzene': {'comp_1': 'Ethanol',
  'comp_2': 'Benzene',
  'name_cn': '乙醇-苯',
  'name_en': 'Ethanol / Benzene',
  'abbr': 'Ethanol_Benzene',
  'modelParams': {'Lambda_12': 0.250415, 'Lambda_21': 0.448481}},
 'CCl4_Ethanol': {'comp_1': 'CCl4',
  'comp_2': 'Ethanol',
  'name_cn': '四氯化碳-乙醇',
  'name_en': 'CCl4 / Ethanol',
  'abbr': 'CCl4_Ethanol',
  'modelParams': {'Lambda_12': 0.490952, 'Lambda_21': 0.053897}},
 'Chexane_Ethanol': {'comp_1': 'Chexane',
  'comp_2': 'Ethanol',
  'name_cn': '环己烷-乙醇',
  'name_en': 'Cyclohexane / Ethanol',
  'abbr': 'Chexane_Ethanol',
  'modelParams': {'Lambda_12': 0.305261, 'Lambda_21': 0.124253}},
 'Water_CH2O2': {'comp_1': 'Water',
  'comp_2': 'CH2O2',
  'name_cn': '水-甲酸',
  'name_en': 'Water / Formic Acide',
  'abbr': 'Water_CH2O2',
  'modelParams': {'Lambda_12': 3.06678, 'Lambda_21': 0.12648}}};

 export const binary_sys_nrtl = {'Ethanol_Benzene': {'comp_1': 'Ethanol',
  'comp_2': 'Benzene',
  'name_cn': '乙醇-苯',
  'name_en': 'Ethanol / Benzene',
  'abbr': 'Ethanol_Benzene',
  'modelParams': {'Tau_12': 0.55481,
   'Tau_21': 1.371348,
   'Alpha': 0.29100000000000004}},
 'CCl4_Ethanol': {'comp_1': 'CCl4',
  'comp_2': 'Ethanol',
  'name_cn': '四氯化碳-乙醇',
  'name_en': 'CCl4 / Ethanol',
  'abbr': 'CCl4_Ethanol',
  'modelParams': {'Tau_12': 3.209875, 'Tau_21': 1.147969, 'Alpha': 0.5143}},
 'Chexane_Ethanol': {'comp_1': 'Chexane',
  'comp_2': 'Ethanol',
  'name_cn': '环己烷-乙醇',
  'name_en': 'Cyclohexane / Ethanol',
  'abbr': 'Chexane_Ethanol',
  'modelParams': {'Tau_12': 1.878685, 'Tau_21': 1.228593, 'Alpha': 0.4671}},
 'Water_CH2O2': {'comp_1': 'Water',
  'comp_2': 'CH2O2',
  'name_cn': '水-甲酸',
  'name_en': 'Water / Formic Acide',
  'abbr': 'Water_CH2O2',
  'modelParams': {'Tau_12': -0.097489, 'Tau_21': 0.025923, 'Alpha': 12.0396}}};

export const binary_sys = {'Wilson': binary_sys_wilson,
                            'NRTL': binary_sys_nrtl,
                          }